import { Atom } from 'AppReact';
import styled, { css, keyframes } from "styled-components";

export const changeColor = (theme) => keyframes`
  0% {
    color: ${theme?.colour?.secondary};
  }

  30% {
    color:  white;
  }

  100% {
    color:  white;
  }
`;

const template = styled.div`
  ${({ theme, displayState }) => css`
    position: absolute;
    left: 4px;
    margin-left: ${displayState.hidden ? '' : '8px'};
    visibility: ${displayState.hidden ? 'hidden' : 'visible'};
    color: ${theme?.colour?.secondary};

    svg {
      display: flex !important;
    }

    &:hover {
      animation: ${changeColor(theme)} 1.5s infinite;
    }
  `}
`;


export default Atom({ type: 'label', dataType: 'object', template })